import { Stack, Text } from '@mantine/core';
import Markdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';

import 'katex/dist/katex.min.css';

// The tutor writes for a child reading a screen, which means the occasional
// bold word and, in a maths app, real fractions. A fraction rendered as
// `\frac{1}{2}` is a fraction a nine-year-old cannot read, so KaTeX renders it
// and `lib/text.ts` strips it again before anything is spoken.
export function TutorText({ children }: { children: string }) {
  return (
    <Stack gap="xs">
      <Markdown
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex]}
        // A paragraph is a Mantine Text, so the bubble's spacing comes from
        // the Stack rather than from the browser's margins around a <p>.
        components={{ p: ({ children }) => <Text>{children}</Text> }}
      >
        {children}
      </Markdown>
    </Stack>
  );
}
